import api from '../utils/apiUtils';

const API_URL = '/ebook-content/';

const METADATA_URL = '/metadata/';

export const fetchAllMetadata = async () => {
  try {
    const resp = await api.post(METADATA_URL + 'list-all-metadata', {});
    const metadata = resp.data;
    return metadata;
  } catch (error) {
    console.error('Error fetching metadata:', error);
    throw error;
  }
}

// Fetch all ebooks
export const fetchEbooks = async () => {
  try {
    const resp = await api.post(API_URL + 'list-ebook-content', {});
    const ebooks = resp.data
    console.log(ebooks);
    return ebooks;
  } catch (error) {
    console.error('Error fetching ebooks:', error);
    throw error;
  }
};





// Get ebook by ID
export const fetchEbookById = async (id) => {
  try {
    const allEbooks = await fetchEbooks();
    const ebook = allEbooks.find(e => e.id === id);
    if (ebook) {
      return ebook;
    } else {
      throw new Error('Ebook not found');
    }
  } catch (error) {
    console.error('Error fetching ebook by ID:', error);
    throw error;
  }
};

// Helper function to parse comma-separated values or return array as-is
const parseCommaSeparated = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string') {
    return value.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }
  return [];
};

// Filter ebooks
export const filterEbooks = (ebooks, searchTerm = '', categoryFilter = '') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filtered = ebooks;
      
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(ebook => {
          const tags = parseCommaSeparated(ebook.tags || '');
          
          return ebook.title.toLowerCase().includes(term) ||
                 ebook.excerpt.toLowerCase().includes(term) ||
                 ebook.fullContent.toLowerCase().includes(term) ||
                 tags.some(tag => tag.toLowerCase().includes(term));
        });
      }
      
     
      
      if (categoryFilter) {
        filtered = filtered.filter(ebook => {
          return ebook.categoryName === categoryFilter;
        });
      }
      
      resolve(filtered);
    }, 400);
  });
};

// Get unique categories for filter options
export const getFilterOptions = (ebooks) => {
  const allCategories = new Set();
  
  ebooks.forEach(ebook => {
    const categories = parseCommaSeparated(ebook.categories);
    
    categories.forEach(category => allCategories.add(category));
  });
  
  return {
    categories: Array.from(allCategories).sort()
  };
}; 